import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function CaseManagement(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "CaseManagement",
      sx,
      viewBox,
      children: [
        /* @__PURE__ */ jsx("path", { d: "M15.204 41.919H5V21.51h20.408v20.41H15.204Z", fill: theme.vars.palette.primary.light }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M15.572 24.572a1.02 1.02 0 0 1-.888-1.531l4.275-7.53a1.02 1.02 0 0 1 1.347-.348 1.02 1.02 0 0 1 .388 1.398l-4.276 7.531a1.02 1.02 0 0 1-.846.48Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M18.826 19.572a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", fill: theme.vars.palette.primary.dark }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M19.285 28.653h-8.163a1.02 1.02 0 0 1 0-2.04h8.163a1.02 1.02 0 0 1 0 2.04Zm0 4.082h-8.163a1.02 1.02 0 0 1 0-2.041h8.163a1.02 1.02 0 0 1 0 2.04Zm0 4.081h-8.163a1.02 1.02 0 0 1 0-2.04h8.163a1.02 1.02 0 0 1 0 2.04Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M19.287 25.592h20.408V46H19.287V25.592Z", fill: theme.vars.palette.primary.light }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M29.857 28.653a1.02 1.02 0 0 1-.888-1.53l4.275-7.531a1.02 1.02 0 0 1 1.347-.347 1.02 1.02 0 0 1 .388 1.398l-4.276 7.53a1.02 1.02 0 0 1-.846.48Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M33.113 23.653a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", fill: theme.vars.palette.primary.dark }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M33.572 32.735H25.41a1.02 1.02 0 0 1 0-2.041h8.163a1.02 1.02 0 0 1 0 2.04Zm0 4.081H25.41a1.02 1.02 0 0 1 0-2.04h8.163a1.02 1.02 0 0 1 0 2.04Zm0 4.082H25.41a1.02 1.02 0 0 1 0-2.04h8.163a1.02 1.02 0 0 1 0 2.04ZM35.735 2h-8.163a6.123 6.123 0 0 0-6.123 6.122v2.041a6.123 6.123 0 0 0 6.123 6.123v4.081l4.081-4.081h4.082a6.122 6.122 0 0 0 6.122-6.123v-2.04A6.122 6.122 0 0 0 35.735 2Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M35.734 8.122h-8.163a1.02 1.02 0 1 1 0-2.04h8.163a1.02 1.02 0 0 1 0 2.04Zm0 4.082h-8.163a1.02 1.02 0 1 1 0-2.04h8.163a1.02 1.02 0 0 1 0 2.04Z",
            fill: theme.vars.palette.primary.dark
          }
        )
      ]
    }
  );
}
CaseManagement.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "CaseManagement"
};
validateTidalLicense();
export {
  CaseManagement
};
//# sourceMappingURL=CaseManagement.js.map
